import React from "react";
import Button from "../../../components/Button/Button"
import { useUserStore } from "../../../store/useUser";

import styles from './Book.module.scss';

interface AddBookButton {
  onClick: (...args: any) => unknown;
  loading: boolean
}

//qualquer um pode cadastrar um livro?
const AddBookToBookcaseButton = ({ onClick, loading }) => {
  const userId = useUserStore(state => state?.id);
  const profile = useUserStore(state => state?.profile);

  if(!userId) return null

  return (
    <Button
      style={styles.button}
      loading={loading}
      onClick={onClick}
    >
      {['Mediador', 'Criador'].includes(profile) ? "Adicionar à estante do clube" : "Adicionar à sua estante"}
    </Button>
  )
}

export { AddBookToBookcaseButton };